import { ApiConfig } from './types';

export const defaultConfig: ApiConfig = {
  api: {
    api: process.env.REACT_APP_API_URL || 'http://localhost:8081/api',
    // old: '/api',
    old: process.env.REACT_APP_OLD_API_URL || '/api/v2',
  },
  withCredentials: true,
};

export const StoreBase = {
  config: defaultConfig,
};

const convertToBoolean = (value: any): boolean => {
  return String(value) === 'true';
};

export const apiUrl = () => StoreBase.config.api.api;
export const oldUrl = () => StoreBase.config.api.old;
